module.exports = __webpack_public_path__ + "images/changyongshuju_black.svg";